// A dry-weather flow/pollutant loading at a node, with up to 4 time
// patterns — any pattern TYPE in any of the 4 slots, the engine matches
// each by its own stored type at simulation time, not by slot position.

import { parseNum } from "./parseNum.ts";
import { writeOrDeleteSection } from "./writeOrDeleteSection.ts";

export interface DwfInflow {
  node: string;
  constituent: string;
  avgValue: number;
  patterns: [string, string, string, string];
}

export function readDwf(raw: ReadonlyMap<string, string[][]>, warnings?: Set<string>): DwfInflow[] {
  return (raw.get("DWF") ?? [])
    .filter((row) => row[0] && row[1])
    .map((row) => ({
      node: row[0],
      constituent: row[1],
      avgValue: parseNum(row[2], 0, `[DWF] "${row[0]}" "${row[1]}" AvgValue`, warnings),
      patterns: [row[3] ?? "", row[4] ?? "", row[5] ?? "", row[6] ?? ""],
    }));
}

export function writeDwf(
  raw: ReadonlyMap<string, string[][]>,
  inflows: DwfInflow[]
): Map<string, string[][]> {
  const rows = inflows.map((i) => {
    const row = [i.node, i.constituent, String(i.avgValue)];
    // Trailing empty slots are omitted entirely; a gap before a later
    // filled slot still needs its own empty token (serialized as `""`,
    // see serializeInp.ts's own formatToken) so pattern positions stay
    // aligned — slot 2 must never shift into slot 1's column.
    let lastFilled = -1;
    for (let i2 = 0; i2 < 4; i2++) if (i.patterns[i2]) lastFilled = i2;
    for (let i2 = 0; i2 <= lastFilled; i2++) row.push(i.patterns[i2]);
    return row;
  });
  return writeOrDeleteSection(raw, "DWF", rows);
}
